export default function HowItWorks() {
  const steps = [
    {
      num: '01',
      icon: 'ri-group-line',
      bg: 'bg-primary-500',
      title: 'Create a CareBridge Circle',
      desc: 'Add your elderly parent and invite trusted family members or caregivers to join the circle.',
    },
    {
      num: '02',
      icon: 'ri-list-check-2',
      bg: 'bg-secondary-500',
      title: 'Set up daily care routines',
      desc: 'Add medications, meal reminders, doctor visits, and daily check-ins tailored to your loved one\'s needs.',
    },
    {
      num: '03',
      icon: 'ri-notification-3-line',
      bg: 'bg-accent-500',
      title: 'Stay connected',
      desc: 'Family and caregivers receive updates, reminders, and alerts so everyone stays in the loop.',
    },
    {
      num: '04',
      icon: 'ri-alarm-warning-line',
      bg: 'bg-accent-400',
      title: 'Respond quickly when needed',
      desc: 'Use the emergency SOS system to notify the right people fast when something urgent happens.',
    },
  ];

  return (
    <section id="how-it-works" className="bg-white py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-4">
            How CareBridge works
          </h2>
          <p className="text-base md:text-lg text-foreground-600/80 max-w-xl mx-auto">
            Getting started is simple. Set up your care circle in minutes and start caring together.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, idx) => (
            <div key={idx} className="relative group">
              <div className="bg-background-200/70 rounded-2xl p-6 h-full border border-background-200/70 hover:border-primary-500/20 transition-all duration-300 group-hover:shadow-md">
                <div className="text-4xl font-bold text-foreground-600/10 mb-4 group-hover:text-primary-500/10 transition-colors">
                  {step.num}
                </div>
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${step.bg} mb-4`}>
                  <i className={`${step.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mb-2">{step.title}</h3>
                <p className="text-sm text-foreground-600/80 leading-relaxed">{step.desc}</p>
              </div>
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 -right-3 w-6 h-px bg-foreground-600/10 group-hover:bg-primary-500/20 transition-colors"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}